import { createSlice } from '@reduxjs/toolkit'
import {
  SLICE_CHECK_IN,
} from './type'

const initialState = {
  isLoading: false,
}

export const checkInSlice = createSlice({
  name: SLICE_CHECK_IN,
  initialState: initialState,
  reducers: {
    checkIn: (state) => {
      return {
        ...state,
        isLoading: true,
        errors: null,
      }
    },
  },
})

export const {
  checkIn,
} = checkInSlice.actions
export default checkInSlice.reducer
